import { NodeEvents } from "~/js/types/IEventorListners";
import type { nodeNewExecutor } from "~/js/utilities/changeNodeExecutorOnCustom";

export const dbExecutor: nodeNewExecutor = (node, layout, initialExecutor) => {
	initialExecutor(node, layout);
	const uniqueName = node.inputSocketGroup.socketHashMap.get("unique_name");
	const subject = node.inputSocketGroup.socketHashMap.get("object_token");
	if (!uniqueName || !subject) return;
	node.addListener(NodeEvents.PreExecutePreparing, () => {
		const uniqueNameVal = uniqueName.tryGetValue();
		const subjectVal = subject.tryGetValue();
		if (typeof subjectVal === "string" && subjectVal.includes(uniqueNameVal)) return;
		subject.setValue(`${uniqueNameVal} ${subjectVal}`);
	});
};
